import { Component, OnInit } from '@angular/core';
import { MetaphorsService } from '@app/services/metaphors.service';
import { NavigationService } from '@app/services/navigation/navigation.service';
import { SettingsService } from '@app/services/settings/settings.service';
import { AdsModule } from '@app/shared/ads.module';
import { SharedModule } from '@app/shared/shared.module';

@Component({
	selector: 'app-summary',
	standalone: true,
	imports: [
		SharedModule,
		AdsModule,
	],
	providers: [
		MetaphorsService,
	],
	templateUrl: './summary.component.html',
	styleUrl: './summary.component.scss'
})
export class SummaryComponent implements OnInit {
	public loading:boolean = false;
	public year:string = "...";
	public open:boolean = false;
	public signMessage:string = "...";
	public metaphor:string = "morrer";

	constructor(
		private settings: SettingsService,
		public nav: NavigationService,
	) { }

	ngOnInit(): void {
		this.loadMetaphor();
		this.loadSettings();
	}
	
	private async loadSettings() {
		this.year = (await this.settings.getSubscriptionYear()).toString();
		this.open = await this.settings.isOpen();
		if(this.open) {
			this.signMessage = `As inscrições para ${this.year} já estão abertas!`;
		} else {
			this.signMessage = `As inscrições de novas listas se abrirão em breve!`;
		}
	}

	private loadMetaphor() {
		this.metaphor = MetaphorsService.giveMeInfinitive();
	}

}
